// client/src/shared/username.js
// Mirrors server/src/utils/username.js so creation forms can preview what
// the server will assign. Display-only — the server has the final say and
// resolves the uniqueness number; this value is never sent to the API.

const SECTOR_ABBR = {
  manufacturing:    'MFG',
  wholesale_retail: 'WHS',
};

// Preview only ever shows "1" for the number — the server tries 1 upward
// until it finds a free username, but the actual count of existing
// NSA<SECTOR>-*-<initials> accounts isn't known client-side.
export const previewUsername = (firstName, lastName, sectorType) => {
  const first = (firstName || '').trim()[0] || '';
  const last  = (lastName  || '').trim()[0] || '';
  if (!first || !last) return '';
  const abbr = SECTOR_ABBR[sectorType] || '';
  return `NSA${abbr}-1-${(first + last).toUpperCase()}`;
};

// Matches any auto-generated username: NSA, an optional sector code, a
// dash, a uniqueness number, a dash, and two initials.
export const NSA_USERNAME_PATTERN = /^NSA[A-Z]*-\d+-[A-Z]{2}$/;
